import { englishMessages, co2 } from './common';

export default {
  'consumption.co2': `Średnia emisja ${co2}`,
  'consumption.energy': 'Zużycie energii',
  'consumption.fuel': 'Średnie zużycie paliwa',
  'footnotes.local': '',
  'footnotes.wltp': `Podane wartości zostały oznaczone zgodnie z metodą pomiarową określoną przepisami. Są to „wartości ${co2} WLTP”, w rozumieniu Art. 2 nr 3 rozporządzenia wykonawczego (UE) 2017/1153. Parametry zużycia paliwa zostały obliczone na podstawie tych danych. Zużycie prądu obliczono zgodnie z rozporządzeniem 683/2008/WE. Dane nie dotyczą konkretnego pojazdu i nie są częścią oferty, lecz służą jedynie porównaniu różnych typów pojazdu. Wartości różnią się w zależności od wybranego wyposażenia dodatkowego i mogą się różnić od końcowych wartości zamówionego wzgl. dostarczonego pojazdu.`,
  'footnotes.nedc': `Podane wartości ustalono zgodnie z przewidzianą przepisami procedurą pomiarową. Są to „wartości ${co2} WLTP” w rozumieniu Art. 2 pkt 3 rozporządzenia wykonawczego (UE) 2017/1153. Wartości zużycia paliwa obliczono na bazie tych danych. Dane nie dotyczą konkretnego pojazdu i nie są częścią oferty, lecz służą jedynie porównaniu różnych typów pojazdu. Wartości różnią się w zależności od wybranego wyposażenia dodatkowego i mogą się różnić od końcowych wartości zamówionego wzgl. dostarczonego pojazdu. Zużycie prądu zostało określone na podstawie rozporządzenia 692/2008/WE.`,
  'footnotes.emissions.appendix': `Więcej informacji na temat oficjalnego zużycia paliwa oraz poziomu emisji ${co2} nowych samochodów osobowych można uzyskać u autoryzowanych dealerów Mercedes-Benz.`,
  'search.input.label': 'Wyszukiwane słowo / kod online',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'Nie znaleziono wyników | Wynik wyszukiwania: {count} | Wyniki wyszukiwania: {count}',
  'search.results.count': ' Wyniki wyszukiwania: {count}',
  'search.results.backup': 'Nie znaleziono dokładnych dopasowań. Wyświetl powiązane strony:',
  'search.results.none.summary':
    'Brak dostępnych wyników wyszukiwania dla tego słowa. Spróbuj ponownie, używając innego słowa.',
  'search.show-more': 'Pokaż więcej',
  'search.unavailable': 'Wyszukiwanie nie jest obecnie dostępne.',
  'search.result.new': 'Nowy',

  'input.placeholder': 'Wyszukiwane słowo / kod online',

  'suggestions.all_search_results': 'Wszystkie rezultaty wyszukiwania',
  'suggestions.all_search_results_for': 'Pokaż wszystkie rezultaty wyszukiwania dla',
  'suggestions.in': 'w',

  all: 'Wszystkie',
  UCOS: 'Salon Online z samochodami używanymi',
  PASSENGER_CARS: 'Samochód osobowy',
  VANS: 'Vany',
  NCOS: 'Salon Online z samochodami nowymi',
  VIDEO: 'Filmy',
  DEALER_LOCATOR: 'Wyszukiwanie dealerów',
  CONFIGURATOR: 'Konfigurator',
  TEST_DRIVE: 'Jazda testowa',
  VEHICLE_SEARCH: 'Wyszukiwarka samochodów używanych',
  COLLECT: 'Kolekcja i akcesoria',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Akcesoria samochodowe',

  'search.result.consumption': 'Konsumpcja',
  'watch.video': 'Obejrzyj wideo',
  'input.recently': 'Ostatnio wyszukiwane',
  'input.help.title': 'Czego powinieneś szukać?',
  'input.help.text':
    'Szukaj według typów pojazdów, modeli, kodów konfiguracyjnych lub akcesoriów, innych produktów i informacji',

  // No results found
  'support.check': 'Sprawdź, czy we frazie nie ma literówek lub wpisz inną frazę.',
  'support.no.results': 'Nie znaleziono wyników pasujących dla podanej frazy.',
  'support.no.results.term': 'Nie znaleziono wyników',
  'support.chat': 'Nie możesz znaleźć tego, czego szukasz? Skontaktuj się z naszym',
  'support.chat.with.us': 'Czatem Pomocy Online',

  'search.results.offer': 'Popularne oferty dla "{query}":',
};
